// extracted by mini-css-extract-plugin
export default {"appleButton":"q4yT6k8mU0fSy3pqMkoM","signinWithApple":"Xf006ySAfKy26UbwM1EI"};